'use strict';
import 'core-js/modules/es.promise.all-settled'
import './i18n';
import ReactDOM from 'react-dom';
import React, {useEffect} from 'react';
import {HashRouter} from "react-router-dom";
import App from './App';
import Spinner from "./components/Spinner";

(function() {
  const {regRecallData} = window;
  if (!regRecallData) return;
  const {domain, siteName} = regRecallData;
  if (!domain || !siteName) return;
  for (let fieldName in regRecallData) {
    window.sessionStorage.setItem(`alter-${fieldName}`, JSON.stringify(regRecallData[fieldName]));
  }
  // if (domain && /* avtest.it */ siteName /* avtest */) {
  const item = {
    domain: domain,
    finalPrice: 0,
    isAvailable: true,
    name: siteName,
    price: 0,
    yearPrice: 0
  };
  window.sessionStorage.setItem('altervistaSelectedItem', JSON.stringify(item));
  switch (domain) {
    case '.altervista.org':
      window.location.hash = '#step-2-altervista';
      break;
    case '.it':
      window.location.hash = '#step-2-it';
      break;
    default:
      window.location.hash = '#step-2-other';
      break;
  }
}());

ReactDOM.render(
  <React.Suspense fallback={<Spinner isVisible={true}/>}>
    <HashRouter hashType='noslash'>
      <App style={{height: '100%'}} />
    </HashRouter>
  </React.Suspense>,
  document.getElementById('registrationForm-root')//, callback
);